// Template Dashboard 2 MUI Base Styles
import colors from "assets/theme-dark/base/colors";

const { background } = colors;

const paper = {
  defaultProps: {

  },

  styleOverrides: {
    root: {
      backgroundColor: background.default
    },
  },
};

export default paper;
